// Custom
import actions from "./actions.json";
import columns from "./columns.json";
import common from "./common.json";
import components from "./components.json";
import customAuth from "./custom/auth.json";
import customProjectDetail from "./custom/project-detail.json";
import customProject from "./custom/project.json";
import entity from "./entity.json";
import enums from "./enums.json";
import errors from "./error-codes.json";
import fields from "./fields.json";
import info from "./info.json";
import modals from "./modals.json";
import qrScanner from "./qr-scanner.json";
import routes from "./routes.json";
import shift from "./shift.json";

export const nlTranslations = {
  "error-codes": errors,

  // Custom translations
  "custom-auth": customAuth,
  "custom-project": customProject,
  "custom-project-detail": customProjectDetail,
  common: common,
  fields: fields,
  info: info,
  columns: columns,
  entity: entity,
  actions: actions,
  routes: routes,
  modals: modals,
  enums: enums,
  shift: shift,
  components: components,
  "qr-scanner": qrScanner,
};
